module.exports = __webpack_public_path__ + "img/sorting.37d7317e.svg";